import { Observable } from 'rxjs'
import { AppfeaturesettingattributeModel } from '../models/appfeaturesettingattribute-table-model'
import { AppfeaturesettingvalueModel } from '../models/appfeaturesettingvalue-table-model'
import { OrgAppFeatureModel } from '../models/orgappfeature-table-model'

export abstract class SettingGatewayGateway {
    abstract getAppFeatureSettingAttributes(appFeatureSettingValueId: number): Observable<AppfeaturesettingattributeModel[]>
    abstract getAppFeatureSettingById(orgAppFeatureId: number): Observable<AppfeaturesettingvalueModel[]>
    abstract getAppFeatureSettings(appFeatureId: number, orgId: number): Observable<AppfeaturesettingvalueModel[]>
    abstract getOrgAppFeaturesById(orgId: number): Observable<OrgAppFeatureModel[]>
    abstract getOrgAppFeatures(orgName: string, orgLevelId: number): Observable<OrgAppFeatureModel[]>
    abstract getBackgroundCheckRequired(orgId: number): Observable<boolean>
}
